'use client'

import clsx from 'clsx'
import Image from 'next/image'
import Link from 'next/link'
import { useRouter } from 'next/navigation'
import { FC } from 'react'

import { Slider } from '@/widgets/slider'

import { Button } from '@/shared/ui'

import cl from './BannerSlider.module.scss'

export interface BannerProps {}

const sliderImages = [
	`https://storage.yandexcloud.net/tf-bitrix-upload/iport/promo/iphone-17/1.png`,
	`https://storage.yandexcloud.net/tf-bitrix-upload/iport/promo/iphone-17/2.png`,
	`https://storage.yandexcloud.net/tf-bitrix-upload/iport/promo/iphone-17/3.png`,
	`https://storage.yandexcloud.net/tf-bitrix-upload/iport/promo/iphone-17/4.png`,
	`https://storage.yandexcloud.net/tf-bitrix-upload/iport/promo/iphone-17/5.png`,
	`https://storage.yandexcloud.net/tf-bitrix-upload/iport/promo/iphone-17/6.png`
]

export const BannerSlider: FC<BannerProps> = () => {
	const router = useRouter()
	const onButtonClick = async (event: React.MouseEvent<HTMLButtonElement>) => {
		event.stopPropagation()
		router.push(`/order/1385167,1385160?kod=148734`)
	}
	return (
		<div className={cl.root}>
			<Slider
				className={cl.slider}
				autoplay={false}
				slides={sliderImages.map(src => (
					<Image
						src={src}
						key={src}
						alt=""
						width={598}
						height={460}
						className={clsx(cl.img, cl.img_desktop)}
						priority={true}
					/>
				))}
			/>

			<div className={cl.content}>
				<span className={cl.topTextWrap}>
					<span className={cl.topText}>Лимитированное предложение</span>
				</span>
				<p className={cl.title}>
					Сертификат на покупку iPhone 17 + Limited Box
					<span className={cl.titleCounter}>100 шт.</span>
				</p>
				<p className={cl.discount}>5 000 ₽ + 7 990 ₽</p>
				<p className={cl.price}>12 990 ₽ </p>

				<Button size="L" className={cl.button} onClick={onButtonClick}>
					Купить
				</Button>

				<p className={cl.listTitle}>Cостав бокса:</p>
				<ol className={cl.list}>
					<li className={cl.listItem}>Уникальная коробка с порядковым номером от 1 до 100</li>
					<li className={cl.listItem}>Предусмотренное место для вложения нового iPhone 17</li>
					<Link prefetch={false} href={'/products/productID148731/'}>
						<li className={cl.listItem}>
							Внешний аккумулятор c БЗУ VLP Diamond Energy на 5000 мАч — <b>5 995 ₽</b> <s>6 990 ₽</s>
						</li>
					</Link>
					<Link prefetch={false} href={'/products/productID147021/'}>
						<li className={cl.listItem}>
							Зарядное устройство сетевое VLP G-Charge USB-C на 45Вт — <b>1 995 ₽</b> <s>2 490 ₽</s>
						</li>
					</Link>
					<li className={cl.listItem}>Набор лимитированных стикеров и открытка с пожеланиями</li>
				</ol>
			</div>
		</div>
	)
}
